import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlignLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/AlignLeftOutlined";
import AntdIcon from '../components/AntdIcon';
var AlignLeftOutlined = function AlignLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: AlignLeftOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(AlignLeftOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'AlignLeftOutlined';
}
export default RefIcon;